import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/store';
import { isEmpty } from 'lodash';

import Dashboard from '@/views/dashboard/Dashboard.vue';
import Login from '@/views/login/Login.vue';
import ForgotPassword from '@/views/forgot-password/ForgotPassword.vue';
import RecoveryEmailSent from '@/views/forgot-password/recovery-email-sent/RecoveryEmailSent.vue';
import Sensors from '@/views/sensor/list/SensorList.vue';
import Stations from '@/views/station/list/StationList.vue';
import Alerts from '@/views/alerts/list/AlertList.vue';
import SensorOffline from '@/views/sensor/details/offline/SensorOffline.vue';
import SensorDetails from '@/views/sensor/details/active/SensorDetails.vue';
import StationDetails from '@/views/station/details/active/StationDetails.vue';
import SensorProvisioning from '@/views/sensor/provisioning/SensorProvisioning.vue';
import Profile from '@/views/user/profile/Profile.vue';
import AlertsDetails from '@/views/alerts/details/AlertsDetails.vue';
import TaskBoard from '@/views/task/board/TaskBoard.vue';
import CreateTask from '@/views/task/create/CreateTask.vue';
import ComingSoon from '@/components/comingSoon/ComingSoon.vue';

import ChangePassword from '@/views/user/change-password/ChangePassword.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/recovery-email-sent',
    name: 'RecoveryEmailSent',
    component: RecoveryEmailSent,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: Alerts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/alerts-details',
    name: 'AlertsDetails',
    component: AlertsDetails,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sensors',
    name: 'Sensors',
    component: Sensors,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sensor-offline',
    name: 'SensorOffline',
    component: SensorOffline,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sensor-details',
    name: 'SensorDetails',
    component: SensorDetails,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sensor-provisioning',
    name: 'SensorProvisioning',
    component: SensorProvisioning,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/stations',
    name: 'Stations',
    component: Stations,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/station-details',
    name: 'StationDetails',
    component: StationDetails,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/task-create',
    path: '/task-board',
    name: 'TaskBoard',
    component: TaskBoard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/create-task',
    name: 'CreateTask',
    component: CreateTask,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sync',
    name: 'Sync',
    component: ComingSoon,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const loggedIn = !isEmpty(store.state.user);

  if (to.meta.requiresAuth && !loggedIn) {
    return next('/login');
  }

  if (!to.meta.requiresAuth && loggedIn) {
    return next('/dashboard');
  }
  setTimeout(function(){
    window.scrollTo({ top: 0});
  }, 500);
  return next();
});

export default router;
